import LoadingDog from "./LoadingDog";

interface LoadingPageProps {
  text?: string;
}
export function LoadingPage({ text }: LoadingPageProps): JSX.Element {
  return (
    <div
      className="w-screen h-screen flex justify-center items-center text-center bg-white"
      role="status"
      aria-live="polite"
    >
      <div>
        <LoadingDog size={16} />
        <div className="text-lg italic">{text}</div>
      </div>
    </div>
  );
}
